export type SvzDroplistPanel = 'ds' | 'ds-directory';

const PANEL_MAX_HEIGHT: Record<SvzDroplistPanel, number> = { ds: 240, 'ds-directory': 340 };

const PANEL_CHROME_HEIGHT = 10;

const SEARCH_BLOCK_HEIGHT = 51;

/**
 * Height of a design-system droplist's virtual list, capped so the pinned search box and the list fit inside the
 * panel's `max-height` (`z-select` `ds` 240px / `ds-directory` 340px). Only the list scrolls, as in the prototype
 * `.sd-pop-dir`; a taller list made the panel scroll too.
 */
export function svzDroplistListHeight(rowsHeight: number, panel: SvzDroplistPanel, hasSearch: boolean): number {
  const room = PANEL_MAX_HEIGHT[panel] - PANEL_CHROME_HEIGHT - (hasSearch ? SEARCH_BLOCK_HEIGHT : 0);
  return Math.min(rowsHeight, room);
}
